<template>
  <div v-if="trigger">
       <ul class="autocomplete-wrapper" :class="heightClass" :style="searchListWidth && searchListWidth > 0 ? `width: ${searchListWidth}px;transition: width .55s ease;` : ''">
        <template v-for="value in categories">
        <li v-if="value.list && value.list.length" class="autcomplete-headers">{{value.name}}</li>
        <li class="autocomplete-result" v-for="autoSuggestedList in value.list" :key="value.list" :class="isSearchHistory ? 'd-flex pl-1 align-items-center' : ''">
            <div v-if="isSearchHistory" class="d-flex">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="20pt" height="20pt" viewBox="0 0 100.000000 100.000000" preserveAspectRatio="xMidYMid meet">
                <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)" fill="#C9C7C7" stroke="#C9C7C7">
                <path d="M385 729 c-22 -11 -54 -34 -72 -51 l-33 -32 0 26 c0 18 -7 29 -20 33 -33 11 -40 -3 -40 -80 0 -83 2 -85 85 -85 34 0 57 5 65 15 18 22 5 45 -26 45 -26 0 -26 0 12 35 93 85 201 87 283 4 84 -83 81 -205 -7 -286 -74 -68 -185 -70 -261 -4 -29 25 -54 24 -59 -2 -9 -48 86 -97 187 -97 155 0 251 95 251 249 0 110 -46 188 -135 230 -60 28 -173 29 -230 0z"/>
                <path d="M474 637 c-2 -8 -4 -46 -2 -86 l3 -72 64 -35 c69 -37 96 -40 96 -9 0 13 -18 29 -52 50 l-52 30 -3 65 c-3 59 -5 65 -26 68 -12 2 -24 -3 -28 -11z"/>
                </g>
              </svg>
            </div>
            <p @click="handleDemo(autoSuggestedList.autosuggest, autoSuggestedList.uniqueId)" class="autocomplete-list text-capitalize">
              <img style="width: 33px;" class="popular-product-imgs" v-if="autoSuggestedList.imageUrl && !autoSuggestedList.imageUrl[0].includes('gif')" v-bind:src="autosuggestpath + path +(autoSuggestedList.imageUrl && autoSuggestedList.imageUrl[0])+'?w=33'" v-bind:alt="autoSuggestedList.autosuggest">


              <img style="width: 33px;" class="popular-product-imgs" v-else-if="autoSuggestedList.imageUrl && autoSuggestedList.imageUrl[0].includes('gif')" v-bind:src="autosuggestpath + path +(autoSuggestedList.imageUrl && autoSuggestedList.imageUrl[0])+'?w=33'" v-bind:alt="autoSuggestedList.autosuggest">
              
              
              <img class="other-category-imgs" v-if="!autoSuggestedList.imageUrl &&  autoSuggestedList.doctype === 'TOP_SEARCH_QUERIES'" v-bind:src="getCategoryWiseImage(autoSuggestedList.doctype)" v-bind:alt="autoSuggestedList.autosuggest">
              {{autoSuggestedList.autosuggest.replace(/[^a-zA-Z0-9]/g, " ")}}
            </p>
        </li>
        </template>
        <!-- Recommended Product Suggestions-->
        <template>
            <!--New Arrival Products-->
            <li v-if="isShowNewArrivalProduct && autoSuggestRecomProduct && autoSuggestRecomProduct.new_arrival_products">
                <span class="autcomplete-headers autcomplete-headers-test">New Launches</span>
                <ul class="p-0">
                    <li v-for="(product,key) in autoSuggestRecomProduct.new_arrival_products" :key="key" class="autocomplete-result">
                        <router-link
                        :to="'/product/' + product.product_slug"
                        >
                            <p class="autocomplete-list text-capitalize">
                                <img style="width: 33px;" class="popular-product-imgs" v-if="product.images && product.images[0]" v-bind:src="autosuggestpath + path +(product.images && product.images[0])+'?w=33'" v-bind:alt="product.product">
                                {{product.product}}
                            </p>
                        </router-link>
                    </li>
                </ul>
            </li>

            <!--Top Selling Products-->
            <li v-if="isShowTopSellProduct && autoSuggestRecomProduct && autoSuggestRecomProduct.top_selling_products">
                <span class="autcomplete-headers autcomplete-headers-test">Trending Products</span>
                <ul class="p-0">
                    <li v-for="(product,key) in autoSuggestRecomProduct.top_selling_products" :key="key" class="autocomplete-result">
                        <router-link
                        :to="'/product/' + product.product_slug"
                        >
                            <p class="autocomplete-list text-capitalize">
                                <img style="width: 33px;" class="popular-product-imgs" v-if="product.images && product.images[0]" v-bind:src="autosuggestpath + path +(product.images && product.images[0])+'?w=33'" v-bind:alt="product.product">
                                {{product.product}}
                            </p>
                        </router-link>
                    </li>
                </ul>
            </li>
        </template>
       </ul>
     </div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  props: [
    'trigger', 'categories', 'demo', 'heightClass', 'searchListWidth', 'isSearchHistory', 'isShowTopSellProduct', 'isShowNewArrivalProduct'
  ],
  data () {
    return {
      staticImg: process.env.STATIC_IMG,
      autosuggestpath: process.env.IMG_BASE_URL,
      path: process.env.PRODUCT_IMG
    }
  },
  name: 'autoCompleteList',
  computed: {
    ...mapGetters(['autoSuggestRecomProduct'])
  },
  methods: {
    getCategoryWiseImage: function (doctype) {
      switch (doctype) {
        case 'TOP_SEARCH_QUERIES':
          return this.staticImg + 'icons/iconfinder_trending-up_2561482 (2).png'
      }
    },
    handleDemo: function (value, uniqueID) {
      let autoSuggestArgArr = [value, uniqueID]
      this.isSearchHistory ? this.$emit('searchEventHandler', value) : this.$emit('demo', autoSuggestArgArr)
    }
  }
}
</script>
<style scoped>
.autocomplete-wrapper {
  padding: 0;
  margin: 0;
  border: 1px solid #eeeeee;
  overflow:auto;
  background: white;
  z-index: 1;
  width: 260px;
}

.autocomplete-wrapper.singleItem {
  height: auto;
}

.autocomplete-wrapper.multipleItem, .autocomplete-wrapper{
  max-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.autcomplete-headers {
  padding-left: 0.5rem;
  font-weight: bold;
  font-size: 13px;
  color: #696E79;
  background-color: #EAEAEC;
  text-transform: uppercase;
}
.autcomplete-headers-test {
  display: inline-block;
  width: 100%;
}

.autocomplete-result {
  list-style: none;
  cursor: pointer;
  font-size: 14px;
  color: #696E79;
  text-decoration: none;
  list-style: none;
}

.autocomplete-result .text {
  text-decoration: none;
}

.autocomplete-list {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  padding: 0.4rem 0.5rem 0.5rem;
}

.popular-product-imgs {
  margin-right:7px;
}

.other-category-imgs {
  height: 12px;
  width: 12px;
  margin-right:7px;
}

@media screen and (max-width: 768px) {
  .autocomplete-wrapper {
    width:100% !important;
    position: fixed;
    left: 0;
    right: 0;
    overflow-y: scroll;
    box-shadow: 0px 15px 10px -15px #a7a9ac;
}
}
</style>



// WEBPACK FOOTER //
// autoCompleteList.vue?5580e402